import { useEffect, useRef } from 'react'
import { useDosPasosStore, solicitudDosPasos } from '@/store/dosPasosStore'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import FlujoDosPasos from './FlujoDosPasos'

/**
 * Se abre cuando la API frena una petición por la 2FA (ver `lib/dosPasos.js`). Al terminar, la
 * petición se repite sola: si el asesor estaba guardando una cotización, se guarda sin volver a
 * pulsar nada. Cerrarlo sin verificar devuelve a la pantalla el error original.
 */
export default function DialogoDosPasos() {
  const motivo = useDosPasosStore((s) => s.motivo)
  const guardarSesion = useDosPasosStore((s) => s.guardarSesion)
  const verificado = useRef(false)
  const abierto = motivo !== null

  useEffect(() => {
    if (abierto) verificado.current = false
  }, [abierto])

  const alVerificar = (sesion2fa) => {
    verificado.current = true
    guardarSesion(sesion2fa)
  }

  // Cerrar tras verificar (p. ej. con los códigos de respaldo a la vista) también deja seguir.
  const cerrar = () => (verificado.current ? solicitudDosPasos.completar() : solicitudDosPasos.cancelar())

  const activar = motivo === 'activar'

  return (
    <Dialog open={abierto} onOpenChange={(abrir) => !abrir && cerrar()}>
      <DialogContent
        className="max-w-md"
        // Un clic fuera no debe cerrar: los códigos de respaldo se enseñan una sola vez.
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{activar ? 'Activa la verificación en dos pasos' : 'Verificación en dos pasos'}</DialogTitle>
          <DialogDescription>
            {activar
              ? 'Las cotizaciones, los levantamientos y las consultas llevan datos de tus clientes: además de la contraseña, tu cuenta de asesor pide un código de tu teléfono.'
              : 'Escribe el código de tu app autenticadora para continuar. Vale 12 horas en esta pestaña.'}
          </DialogDescription>
        </DialogHeader>
        {abierto && (
          <FlujoDosPasos
            key={motivo}
            activado={!activar}
            alVerificar={alVerificar}
            alTerminar={solicitudDosPasos.completar}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
